import { render, staticRenderFns } from "./PainelProplan.vue?vue&type=template&id=70985034"
import script from "./PainelProplan.vue?vue&type=script&lang=js"
export * from "./PainelProplan.vue?vue&type=script&lang=js"
import style0 from "./PainelProplan.vue?vue&type=style&index=0&id=70985034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports